/* Called by dlegend when user changes a layer */

import sourceImageWMS from '../node_modules/ol/source/ImageWMS.js'; // only using to test "instanceof sourceImageWMS"

import {map} from './index.js';
import {changePage} from './changePage.js';

export default function(name, state) {

  if (rwg.layers) {  // if (rwg.legendInitialized)
    let layer = rwg.layers.getLayerByName(name)
    let olLayerName = layer.olLyr
    let olLayer = map.getLayerByTitle(olLayerName)
    rwg.layers.getLayerByName(name).state = state
    let activeLayers = rwg.layers.getActiveDrawLayers(olLayerName).join(',')

    if (olLayer) {
      if (olLayer.getSource && olLayer.getSource() instanceof sourceImageWMS) {  // should expand to include other layer types that have params (multiple server-side layers)
        let imageType = rwg.layers.getImageType(olLayerName)
        let transparent = !imageType.includes('jpeg') // bool - this is in Sources.js also
        olLayer.getSource().updateParams({
          LAYERS: activeLayers,
          FORMAT: imageType,
          TRANSPARENT: transparent,
        });
      }
      // olLyr2 allows a second ol layer for vector labels to be associated with a WMS layer.
      // Using ol's layer 'Group' would be an alternative unless the WMS layer is comprised
      // of multiple layers as is the case with lyrBase. So for example, the public lands
      // polygons can be rendered by mapserv on the shared "lyrBase" WMS layer and a
      // dedicated ol layer can be used to label them. The code below toggles olLyr2
      // on/off in sync with its WMS layer.
      let olLayerName2 = layer.olLyr2
      let olLayer2 = olLayerName2 ? map.getLayerByTitle(olLayerName2) : null

      if (activeLayers) {
        olLayer.setVisible(true);
        if (olLayer2) {
          olLayer2.setVisible(true)
          olLayer2.changed() // force redraw
        }
      } else {
        olLayer.setVisible(false);
        if (olLayer2) {
          olLayer2.setVisible(false)
          olLayer2.changed() // force redraw
        }
      }
    }

    changePage('mappage', false);

    // rwg.config.layerChangeCallback used in sweetwater/htdocs/mapserver/etc/supplemental.php and cpc
    if (typeof rwg.config.layerChangeCallback === 'function') {
      rwg.config.layerChangeCallback(name, state, olLayerName);
    }
  }
}
